import React, { useContext } from 'react'

const KEYBOARD_SHORTCUTS_SETTING_ID = 'gecko_keyboard_shortcuts_enabled'

export type KeyboardShortcutsContextType = {
  keyboardShortcutsEnabled: boolean
  setKeyboardShortcutsEnabled: (enabled: boolean) => void
}

const KeyboardShortcutsContext = React.createContext<
  KeyboardShortcutsContextType | undefined
>(undefined)

function readStoredValue(): boolean {
  // Default to enabled when the user hasn't set a preference yet.
  const stored = localStorage.getItem(KEYBOARD_SHORTCUTS_SETTING_ID)
  return stored === null ? true : stored === 'true'
}

export const KeyboardShortcutsProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [keyboardShortcutsEnabled, internalSet] =
    React.useState<boolean>(readStoredValue)

  const setKeyboardShortcutsEnabled = React.useCallback((enabled: boolean) => {
    localStorage.setItem(KEYBOARD_SHORTCUTS_SETTING_ID, String(enabled))
    internalSet(enabled)
  }, [])

  return (
    <KeyboardShortcutsContext.Provider
      value={{ keyboardShortcutsEnabled, setKeyboardShortcutsEnabled }}>
      {children}
    </KeyboardShortcutsContext.Provider>
  )
}

export const useKeyboardShortcuts = (): KeyboardShortcutsContextType => {
  const context = useContext(KeyboardShortcutsContext)
  if (!context)
    throw new Error(
      'useKeyboardShortcuts() must be used within KeyboardShortcutsProvider'
    )
  return context
}
